<style scoped>

</style>

<template>
    <div>
        <h1>库存管理</h1>
        <div>
            <el-table :data="taskList" border style="width:100%">
                <el-table-column prop="inventoryId" label="ID" width="100"></el-table-column>
                <el-table-column prop="itemName" label="物料名称" width="150"></el-table-column>
                <el-table-column prop="num" label="当前剩余数量" width="120"></el-table-column>
                <el-table-column prop="weekCost" label="近一周消耗数量" width="120"></el-table-column>
                <el-table-column prop="days" label="预计可用天数" width="120">
                    <template slot-scope="scope">
                        <i v-if="scope.row.days <= 7" class="el-icon-warning" style="color:red"></i>
                        {{scope.row.days}}
                    </template>
                </el-table-column>                
                <el-table-column label="消耗记录" width="400">
                    <template slot-scope="scope">
                        <el-popover
                            size="small"
                            type="primary" 
                            placement="bottom-start"
                            width="400"
                            trigger="click">
                            <el-table :data="operateRecordList">
                                <el-table-column width="180" property="dateValue" label="日期"></el-table-column>
                                <el-table-column width="250" property="desc" label="操作内容"></el-table-column>
                            </el-table>
                            <el-button slot="reference" type="primary" @click="getInventoryOperateList(scope.row)">消耗记录</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="updateNum(scope.row, 1)" type="primary" size="small">补货</el-button>
                        <el-button @click="updateNum(scope.row, 2)" type="primary" size="small">报损</el-button>
                        <!-- <el-button @click="getInventoryOperateList(scope.row)" type="primary" size="small">消耗记录</el-button> -->                        
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="currentPage" :page-size="pageSize" @current-change="pageCurrentChange"
            background layout="prev, pager, next" :total="total">
            </el-pagination>

            
        </div>
    </div>
</template>

<script>
import app from '@/App.vue';
import {updateInventoryNum, getInventoryOperateList, getInventoryList} from '@/request/api';
export default {
    name: 'User',
    data() {
      return {
        currentPage: 1,
        pageSize: 10,
        pages: 1,
        total: 0,
        taskList: [{

        }],
        operateRecordList: [{

        }]
      }
    },
    methods: {
        updateNum(row, type) {
            var msg = '请输入增加数量'
            if (type == 2) {
                msg = '请输入报损数量'
            }
            this.$prompt(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^[0-9]{1,3}$/,
                inputErrorMessage: '输入格式不正确'
                }).then(({ value }) => {
                    this.updateInventoryNum(row, value, type);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消操作'
                    });       
            });
        },
        updateInventoryNum(row, num, type) {
            updateInventoryNum({
                inventoryId: row.inventoryId,
                num: num,
                operateType: type
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("操作成功");
                    this.onSubmit();
                }
            })
        },
        getInventoryOperateList(row) {
            getInventoryOperateList({
                inventoryId: row.inventoryId
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("查询成功");
                    var data = res.data;
                    this.operateRecordList = data
                }
            })
        },
        onSubmit() {
            getInventoryList({
                page: this.currentPage,
                size: this.pageSize
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("查询成功");
                    var data = res.data;
                    this.taskList = data.list;
                    this.currentPage = data.pageNum;
                    this.pagea = data.pages;
                    this.total = data.total;
                }
            })
        },
        pageCurrentChange(val) {
            this.currentPage = val;
            this.onSubmit()
        },
        taskTypeFormatter(data) {
            if (data.taskType === 0) {
                return '初始';
            }
            if (data.taskType === 1) {
                return '猫卡操作';
            }
            if (data.taskType === 2) {
                return '每日活动';
            }
        }
    },
    created(){
        this.onSubmit();
    }
}
</script>



// WEBPACK FOOTER //
// src/page/task/inventory.vue